import React from "react";
import Carousel from "react-material-ui-carousel";
import NavigateNext from "@material-ui/icons/NavigateNext";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import FormatQuote from "@material-ui/icons/FormatQuote";

import { kickBlue } from "~/shared/styles/baseStyles.js";

export default function TestimonialsCarousel() {
  var items = [
    {
      name: "Robert D.",
      description:
        "Kick is a lifesaver! Their service made getting propranolol for my anxiety a breeze. Quick, caring, and affordable. What stood out to me was their genuine concern for my well-being. Highly recommend!",
    },
    {
      name: "Shane Curtis",
      description:
        "I am shocked how well this worked for me. I normally have intense anxiety before public speaking engagements, of which I have done many, and this made me feel so much more relaxed. I wish I had discovered this sooner… 10/10 would recommend trying.",
    },
    {
      name: "Elijah Luke",
      description:
        "My career would be over if not for Kick.com and Beta blockers ....i have suffered from crippling anxiety for many years that has caused me loss in opportunities and relationships but thanks to Kick and Beta blockers I am finally gaining my life back....Finding Kick health.com has been a God send 😍",
    },
  ];

  return (
    <Carousel
      swipe={true}
      animation="slide"
      navButtonsAlwaysInvisible={true}
      interval={5000}
      autoPlay={false}
      navButtonsProps={{
        style: {
          backgroundColor: "transparent",
          color: "rgba(150, 150, 150, 0.5)",
          padding: "0",
          fontSize: "55px",
          margin: "0",
        },
      }}
      NextIcon={<NavigateNext fontSize="large" />}
      PrevIcon={
        <NavigateBefore fontSize="large" style={{ marginRight: "-25" }} />
      }
    >
      {items.map((item, i) => (
        <Item key={i} item={item} />
      ))}
    </Carousel>
  );
}

function Item(props) {
  return (
    <div>
      <FormatQuote
        style={{ color: kickBlue, transform: "scale(-1)" }}
        fontSize="large"
      />
      <p>{props.item.description}</p>
      <div
        style={{
          fontWeight: "bold",
        }}
      >
        {props.item.name}
      </div>
    </div>
  );
}
